import React, { useCallback } from 'react';
import { AnyObject } from 'final-form';

import WpDrawer from 'Wpds/components/drawer/WpDrawer';
import { createFormField } from 'Shared/utils/createFormField';
import { useFieldChange } from 'Shared/utils/hooks';

import AddMoreButton from '../../../../DesktopOnboardingWizard/AddMoreButton/AddMoreButton';
import FormFields from './FormFields/FormFields';

import './AddOrUpdateWorkspaceForm.scss';

function AddOrUpdateWorkspaceForm({ value: isOpen, onChange }: AnyObject) {
  const onWorkspaceToCreateOrUpdateChange = useFieldChange('workspaceToCreateOrUpdate');

  const handleOpen = useCallback(() => onChange(true), []);

  const handleClose = useCallback(() => {
    onChange(false);
    onWorkspaceToCreateOrUpdateChange({});
  }, []);

  return (
    <>
      <AddMoreButton action={handleOpen} label="Add Workspace" />
      <WpDrawer orientation="bottom" isOpen={isOpen} onToggle={handleClose}>
        <div className="AddOrUpdateWorkspaceForm py-3 px-2">
          <FormFields onClose={handleClose} />
        </div>
      </WpDrawer>
    </>
  );
}

export default createFormField(AddOrUpdateWorkspaceForm);
